import { render, staticRenderFns } from "./Abacus.vue?vue&type=template&id=275da516&scoped=true&"
import script from "./Abacus.vue?vue&type=script&lang=js&"
export * from "./Abacus.vue?vue&type=script&lang=js&"
import style0 from "./Abacus.vue?vue&type=style&index=0&id=275da516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275da516",
  null
  
)

export default component.exports